module.exports = __webpack_public_path__ + "img/1_028.7d6eeeac.jpg";